import { render } from "./App.vue?vue&type=template&id=24ddb36c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=24ddb36c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__